<template>
  <div class="my_border_layer">
    <my_radio
      :titleWidth="titleWidth"
      :title="title"
      :option="option"
      :defaultIsShow="defaultIsShow"
      :hiddenIsShow="hiddenIsShow"
      :selfIsShow="selfIsShow"
      :defaultIsDisabled="defaultIsDisabled"
      :hiddenIsDisabled="hiddenIsDisabled"
      :selfIsDisabled="selfIsDisabled"
      :selectValue.sync="radio_value"
    >
      <div slot="pull_down_control">
        <my_radio
          :title="$t('widgets_basic_h1_edit_576')"
          :titleWidth="subTitleWidth"
          :option="$store.state.options.inlineSplitLine"
          hiddenIsShow="false"
          :selectValue.sync="split_line_style"
        >
        </my_radio>
        <my_color
          v-if="colorValue"
          :title="colorTitle"
          :titleWidth="subTitleWidth"
          :color.sync="color_value"
          :type="type"
          class="my-color-picker"
        ></my_color>
      </div>
    </my_radio>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_inline_split_line_index',
  props: {
    radioValue: {
      type: String,
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    subTitleWidth: {
      type: String,
      default: '75'
    },
    type: { // 组件的标题
      type: String,
      default: 'two_level'
    },
    title: { // 组件的标题
      type: String,
      default: i18n.t('widgets_basic_article_classification_edit_324')
    },
    colorTitle: { // 组件的标题
      type: String,
      default: i18n.t('view_back_top_edit_99')
    },
    splitLineStyle: {
      type: String,
      default: 'vertical'
    },
    colorValue: {
      type: String
    },
    option: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultIsShow: {
      type: String,
      default: 'true'
    },
    hiddenIsShow: {
      type: String,
      default: 'true'
    },
    selfIsShow: {
      type: String,
      default: 'true'
    },
    defaultIsDisabled: { // 默认设置是否禁用
      type: String,
      default: 'false'
    },
    hiddenIsDisabled: { // 隐藏设置是否禁用
      type: String,
      default: 'false'
    },
    selfIsDisabled: { // 自定义设置是否禁用
      type: String,
      default: 'false'
    },
  },
  data() {
    return {
      radio_value: this.radioValue,
      split_line_style: this.splitLineStyle,
      color_value: this.colorValue,
    }
  },
  computed: {},
  watch: {
    radio_value(val) { // 数据双向绑定
      this.$emit('update:radioValue', val)
    },
    split_line_style(val) {  // 数据双向绑定
      this.$emit('update:splitLineStyle', val)
    },
    color_value(val) { // 数据双向绑定
      this.$emit('update:colorValue', val)
    },
    'radioValue'(val) { // 数据双向绑定
      this.radio_value = val
    },
    'colorValue'(val) { // 数据双向绑定
      this.color_value = val
    },
  },
  methods: {},
  mounted() {
  },
}
</script>

<style scoped lang="scss">
.setOne {
  display: flex;
  justify-content: flex-start;
}

.my-color-picker {
  margin-left: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_inline_split_line/index.vue